import { ItemMenuAcessoRapido } from "../modelo/ItemMenuAcessoRapido";
import Configuracao from "../utils/Configuracao";
import ControleGabineteStore from "./ControleGabineteStore";
import ParametroStore from "./ParametroStore";

import ImgEscaninhoPeticao from '../img/acessoRapido/escaninho-peticao.png';
import ImgMenuGabinete from "../img/acessoRapido/menu-gabinete.png";
import ImgControleGabinete from "../img/acessoRapido/controle-gabinete.png";
import ImgEscaninho from "../img/acessoRapido/escaninho.png";
import ImgEscaninhoGabinete from "../img/acessoRapido/escaninho-gabinete.png";
import ImgEscaninhoRedator from "../img/acessoRapido/escaninho-redator.png";
import ImgEscaninhoVotoVencido from "../img/acessoRapido/escaninho-voto-vencido.png";
import ImgEscaninhoPauta from "../img/acessoRapido/escaninho-de-pauta.png";
import ImgPleno from "../img/acessoRapido/pleno.png";
import ImgJulgamento from "../img/acessoRapido/julgamento.png";
import ImgCategoria from "../img/acessoRapido/categoria.png";
import ImgModelo from "../img/acessoRapido/manuscritos.png";
import ImgMinutasDevolvidas from "../img/acessoRapido/minutasDevolvidas.png";
import ImgAssinaturaDigital from "../img/acessoRapido/assinatura.png";
import ImgDashboard from "../img/acessoRapido/estatistica.png";
import ImgParametro from "../img/acessoRapido/settings2.jpg";
import ImgAM from "../img/assistente-minutas.png";
import ImgGerenMin from "../img/acessoRapido/gerenciador_minutas.png";
import ImgEstruturas from "../img/acessoRapido/estruturas.png";
import ImgTemas from "../img/acessoRapido/temas.png";
import ImgModelosTemas from "../img/acessoRapido/modelos_temas.png";
import ImgAutotexto from "../img/acessoRapido/autotexto.png";
import UsuarioStore
    from "@/store/UsuarioStore";

class MenuAcessoRapidoStore {

    get itensMenuAcessoRapido(): ItemMenuAcessoRapido[] {
        const itens = [{
            title: 'Controle de Gabinete',
            tooltip: 'Controle de processos do gabinete',
            img: ImgControleGabinete,
            route: '/controleGabinete',
            grupos: ['usuario']
        },
        {
            title: 'Escaninho do Usuário',
            tooltip: 'Escaninho do Usuário',
            img: ImgEscaninho,
            route: '/escaninho/usuario',
            grupos: ['usuario']
        },
        {
            title: 'Escaninho do Gabinete',
            tooltip: 'Escaninho do Gabinete',
            img: ImgEscaninhoGabinete,
            route: '/escaninho/gerencial',
            grupos: ['usuario']
        },
        {
            title: 'Escaninho de Vistos',
            tooltip: 'Escaninho de vistos',
            img: ImgPleno,
            route: '/escaninho/vistos',
            grupos: ['usuario']
        },
        {
            title: 'Escaninho de Pauta',
            tooltip: 'Escaninho de Pauta',
            img: ImgEscaninhoPauta,
            route: '/escaninho/pauta',
            grupos: ['usuario'],
            hideFor: !ParametroStore.escaninhoPautaHabilitado
        },
        {
            title: 'Escaninho de Julgamento',
            tooltip: 'Escaninho de julgamento',
            img: ImgJulgamento,
            route: '/escaninho/julgamento',
            grupos: ['usuario']
        },
        {
            title: 'Escaninho de Petições',
            tooltip: 'Escaninho de Petições',
            img: ImgEscaninhoPeticao,
            route: '/escaninho/peticao',
            grupos: ['usuario']
        },
        {
            title: 'Escaninho de Redator Designado',
            tooltip: 'Escaninho de Redator Designado',
            img: ImgEscaninhoRedator,
            route: '/escaninho/redator-designado',
            grupos: ['usuario'],
            hideFor: !ControleGabineteStore.controleRedator
        },
        {
            title: 'Escaninho de Votos Vencidos',
            tooltip: 'Escaninho de Votos Vencidos',
            img: ImgEscaninhoVotoVencido,
            route: '/escaninho/voto-vencido',
            grupos: ['usuario'],
            hideFor: !ControleGabineteStore.controleVotoVencido
        },
        {
            title: 'Categoria de Minutas',
            tooltip: 'Categorias de minutas',
            img: ImgCategoria,
            route: '/categoria',
            grupos: ['usuario']
        },
        {
            title: 'Modelo de Minutas',
            tooltip: 'Modelos de minutas',
            img: ImgModelo,
            route: '/modelosMinuta',
            grupos: ['usuario']
        },
        {
            title: 'Assinaturas',
            tooltip: 'Processos aguardando assinatura',
            img: ImgAssinaturaDigital,
            route: '/escaninho/assinatura',
            grupos: [Configuracao.PERFIL_ASSESSOR, Configuracao.PERFIL_MAGISTRADO, Configuracao.PERFIL_SECRETARIO]
        },
        {
            title: 'Gerenciador de Acervo',
            tooltip: 'Gerenciador de acervo',
            img: ImgDashboard,
            route: '/escaninho/dashboard',
            grupos: [Configuracao.PERFIL_ASSESSOR, Configuracao.PERFIL_MAGISTRADO]
        },
        {
            title: 'Hermes',
            tooltip: 'Hermes - Assistente de Minutas',
            img: ImgAM,
            route: '/assistenteMinutas',
            grupos: ['usuario']
        },
        {
            title: 'Parâmetros do Sistema',
            tooltip: 'Parâmetros do sistema',
            img: ImgParametro,
            route: '/parametroSistema',
            grupos: [Configuracao.SUPER_ADMINISTRADOR]
        },
        {
            title: 'Minutas Devolvidas',
            tooltip: 'Minutas Devolvidas para correção',
            img: ImgMinutasDevolvidas,
            route: '/escaninho/filtrado?situacaoMinuta=70',
            grupos: ['usuario'],
            hideFor: false
        }];

        if (UsuarioStore.ehSecretario) {
            return itens.filter(item => item.title != 'Escaninho de Vistos' && item.title != 'Escaninho de Julgamento' && item.title != 'Escaninho de Pauta');
        } else {
            return itens;
        }

    }

    get itensMenuAcessoRapidoAM(): ItemMenuAcessoRapido[] {
        return [{
            title: 'Temas',
            tooltip: 'Temas',
            img: ImgTemas,
            route: '/assistenteMinutas/temas',
            grupos: ['usuario']
        },
        {
            title: 'Modelos de Temas',
            tooltip: 'Modelos de temas',
            img: ImgModelosTemas,
            route: '/assistenteMinutas/modelosTemas',
            grupos: ['usuario']
        },
        {
            title: 'Estruturas',
            tooltip: 'Estruturas',
            img: ImgEstruturas,
            route: '/assistenteMinutas/estruturas',
            grupos: ['usuario']
        },
        {
            title: 'Autotexto',
            tooltip: 'Autotexto',
            img: ImgAutotexto,
            route: '/assistenteMinutas/autotextos',
            grupos: ['usuario']
        },
        {
            title: 'Gerenciador de Minutas',
            tooltip: 'Gerenciador de minutas',
            img: ImgGerenMin,
            route: '/assistenteMinutas/gerenciarMinutas',
            grupos: ['usuario']
        },
        {
            title: 'Menu Gabinete',
            tooltip: 'Menu do Gabinete Eletrônico',
            img: ImgMenuGabinete,
            route: '/',
            grupos: ['usuario']
        }];
    }
}

export default new MenuAcessoRapidoStore();
